// import React from 'react'

// const StaffProfile = () => {
//   return (
//     <div>StaffProfile</div>
//   )
// }

// export default StaffProfile



import React from 'react';
import './Profile.css';

const Profile = () => {
  return (
    <div className="profile-container">
      {/* Header Section */}
      

      {/* Main Profile Section */}
      <div className="profile-content">
        {/* Left Sidebar */}
        <div className="sidebar">
          <div className="profile-header">
            <img
              src="https://via.placeholder.com/100" // Placeholder for profile image
              alt="Profile"
              className="profile-image"
            />
            <h4>JAYNA PATIL</h4>
            <p>NURSE</p>
            <p>456, Eastern avenue, Courtage area, NEW YORK</p>
            <p>📞 264-625-2583</p>
          </div>
          <div className="social-stats">
            <div>
              <span>564</span>
              <p>FOLLOWING</p>
            </div>
            <div>
              <span>18K</span>
              <p>FOLLOWERS</p>
            </div>
            <div>
              <span>565</span>
              <p>POST</p>
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="main-content">
          <div className="tabs">
            <span className="active-tab">About Me</span>
            <span className="tab">Skills</span>
            <span className="gear-icon">⚙️</span>
          </div>

          {/* About Section */}
          <div className="about-section">
            <div className="info-row">
              <div>
                <h4>FULL NAME</h4>
                <p>Jayna Patil</p>
              </div>
              <div>
                <h4>MOBILE</h4>
                <p>(123) 456 7890</p>
              </div>
              <div>
                <h4>EMAIL</h4>
                <p>johndoe@example.com</p>
              </div>
              <div>
                <h4>LOCATION</h4>
                <p>INDIA</p>
              </div>
            </div>
            <p>
              Completed my graduation in Arts from the well known and renowned institution of India – SARDAR PATEL ARTS COLLEGE, BARODA in 2000-01, which was affiliated to M.S. University. I ranker in University exams from the same university from 1996-01.
            </p>
            <p>
              Worked as Professor and Head of the department at Sarda College, Rajkot, Gujarat from 2003-2015.
            </p>
            <p>
              Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
            </p>
          </div>

          {/* Education Section */}
          <div className="section">
            <h3>Education</h3>
            <p>M.S.N., Gujarat University, Ahmedabad, India.</p>
            <p>B.S.N., Gujarat University, Ahmedabad, India.</p>
            <p>A.S.D., Shaurashtra University, Rajkot, India.</p>
          </div>

          {/* Experience Section */}
          <div className="section">
            <h3>Experience</h3>
            <p>One year nursing internship from April 2009 to March 2010 at B. J. Medical College, Ahmedabad.</p>
            <p>2.5 years worked as Mahatma Gandhi General Hospital, Surendranagar from 1st June 2004 to 31st Jan 2005.</p>
          </div>

          {/* Conferences Section */}
          <div className="section">
            <h3>Conferences, Courses & Workshop Attended</h3>
            <p>Lorem ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p>Lorem ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p>Lorem ipsum is simply dummy text of the printing and typesetting industry.</p>
            <p>Lorem ipsum is simply dummy text of the printing and typesetting industry.</p>
          </div>
        </div>
      </div>

      {/* Skills Section (Previously Contact Info) */}
      <div className="skills-section">
        <h3>Skills</h3>
        <p>
          Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
        </p>
        <p><strong>Email address:</strong> john@gmail.com</p>
        <p><strong>Phone:</strong> +91 1234567890</p>
      </div>
    </div>
  );
};

export default Profile;